module.exports = __webpack_public_path__ + "media/2022/FAFSA-available-annually-d6a20cdf.png";